import mButton from './m-button.vue'

mButton.install = (Vue) =>{
  Vue.component(mButton.name,mButton);
}

export default mButton;




// WEBPACK FOOTER //
// ./src/components/button/index.js